import axios from 'axios';
import { authLocalStorage } from '../lib/storage';

const headers = {
  Accept: 'application/json',
  'Content-Type': 'application/json; charset=utf-8',
};

export const axiosPost = async (payload) => {
  const { apiUrl = process.env.REACT_APP_API_URL, path, body } = payload;
  const authToken = checkAuth(apiUrl);

  if (authToken) {
    headers.auth_token = authToken;
  } else {
    if (headers?.auth_token) {
      delete headers.auth_token;
    }
  }

  const options = {
    method: 'POST',
    url: apiUrl + path,
    headers,
    data: body,
    // withCredentials: true,
  };
  const re = await axios(options);
  return re;
};

export const axiosGet = async (payload) => {
  const { apiUrl = process.env.REACT_APP_API_URL, path, params } = payload;
  const authToken = checkAuth(apiUrl);

  if (authToken) {
    headers.auth_token = authToken;
  } else {
    if (headers?.auth_token) {
      delete headers.auth_token;
    }
  }
  const options = {
    method: 'GET',
    url: apiUrl + path,
    headers,
    params: params ? params : '',
  };
  const re = await axios(options);
  return re;
};

export const axiosPut = async (payload) => {
  const { apiUrl = process.env.REACT_APP_API_URL, path, body } = payload;
  const authToken = checkAuth(apiUrl);

  if (authToken) {
    headers.auth_token = authToken;
  }

  const options = {
    method: 'PUT',
    url: apiUrl + path,
    headers,
    data: body,
  };
  const re = await axios(options);
  return re;
};

const checkAuth = (apiUrl) => {
  const authToken =
    apiUrl === process.env.REACT_APP_API_URL
      ? authLocalStorage().auth
      : process.env.REACT_APP_API_POINT_URL
      ? authLocalStorage().point
      : '';

  return authToken;
};
